import './home.css';

import styled from '@emotion/styled';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsCricketIcon from '@mui/icons-material/SportsCricket';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getImgurl } from '../utils/img_url';

import { API } from '../actions/userAction';
import { URL } from '../constants/userConstants';
import Bottomnav from './navbar/bottomnavbar';
import Steppr from './stepper';

const PlayersContainer = styled.div``;
const Player = styled.div`
  display: flex;
  align-items: center;
  font-family: "Montserrat";
  justify-content: space-between;
  img {
    width: 150px !important;
  }
`;

const PlayerCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #121212;
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 10px;
  color: white;
  transition: 0.3s;
  border: ${(props) => (props.selected ? '2px solid #28a745' : 'none')};
`;

export function Players() {
  const { user } = useSelector((state) => state.user);

  const [players, setPlayers] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  useEffect(() => {
    async function getPlayers() {
      const data = await API.get(`${URL}/getplayers`);
      setPlayers(data.data.players);
    }
    getPlayers();
  }, [user]);

  // 🔥 Select / Unselect Logic
  const togglePlayer = (player) => {
    if (selectedPlayers.find((p) => p._id === player._id)) {
      setSelectedPlayers(selectedPlayers.filter((p) => p._id !== player._id));
    } else {
      if (selectedPlayers.length < 11) {
        setSelectedPlayers([...selectedPlayers, player]);
      } else {
        alert("Only 11 players allowed");
      }
    }
  };

  return (
    <>
      <div className="logintopbar">
        <EmojiEventsOutlinedIcon style={{ marginRight: '1vw' }} />
        Dreamcricket11
      </div>

      <div className="stepper">
        <Steppr />
      </div>

      {/* 🔥 Top Bar */}
      <div className="top-bar">
        <span>{selectedPlayers.length}/11</span>
        <span>Select Players</span>
      </div>

      <PlayersContainer>
        {players.map((u) => {
          const isSelected = selectedPlayers.find((p) => p._id === u._id);

          return (
            <PlayerCard key={u._id} selected={isSelected}>
              
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
  src={getImgurl(u.image)}
  alt="player"
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = "/default-player.png";
  }}
  style={{
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    marginRight: "10px"
  }}
/>
                <div>
                  <h4 style={{ margin: 0 }}>{u.name}</h4>
                  <p style={{ margin: 0, fontSize: "12px" }}>Credits: 9.0</p>
                </div>
              </div>

              <button
                onClick={() => togglePlayer(u)}
                style={{
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  border: "none",
                  background: isSelected ? "green" : "#333",
                  color: "white",
                  fontSize: "18px",
                  cursor: "pointer"
                }}
              >
                {isSelected ? "✔" : "+"}
              </button>

            </PlayerCard>
          );
        })}
      </PlayersContainer>

      {/* 🔥 Bottom Button */}
      <button className="next-btn">
        NEXT
      </button>

      <Bottomnav />
    </>
  );
}

export default Players;
